import m from 'mithril'
import {getSession, signOut} from '../../../client-auth/utils/cognito'
import {getCacheBypassHeader} from '../cache-bypass'

export default async function(){


	const args = Array.from(arguments)

	const redirectToLogin = (e) => {
		console.log('Unauthorized redirecting to login')
		const url = window.location.href
		const path = url.split(window.location.host)[1]
		signOut({redirect: path})

		throw e || new Error('Not Authorized')
	}

	let parameters = typeof args[0] === 'object' ? args[0] : typeof args[1] === 'object' ? args[1] : null
	if(!parameters){
		parameters = {}
		args.push(parameters)
	}

	parameters.background = true

	const cache_header = getCacheBypassHeader()
	if (cache_header) {
		parameters.headers = { ...(parameters.headers || {}), [cache_header.name]: cache_header.value }
	}

	// Extract signal for AbortController support
	const signal = parameters.signal
	delete parameters.signal
	if (signal) {
		const originalConfig = parameters.config
		parameters.config = xhr => {
			if (typeof originalConfig === 'function') originalConfig(xhr)
			if (signal.aborted) xhr.abort()
			signal.addEventListener('abort', () => xhr.abort(), { once: true })
		}
	}

	// Create a promise that rejects on abort
	const requestPromise = m.request(...args).catch(e => {
		if(e.code === 401) redirectToLogin(e)
		throw e
	})

	// If no signal provided, just return the request
	if (!signal) {
		return requestPromise
	}

	// Race with abort signal
	return Promise.race([
		requestPromise,
		new Promise((_, reject) => {
			if (signal.aborted) {
				reject(new DOMException('Aborted', 'AbortError'))
			}
			signal.addEventListener('abort', () => {
				reject(new DOMException('Aborted', 'AbortError'))
			})
		})
	])
}

/**
 * Error message extractor for consistent error handling
 */
export function getErrorMessage(error, defaultMessage = 'An error occurred') {
	const stringifyMessage = value => {
		if (!value) return null
		if (typeof value === 'string') return value === '[object Object]' ? null : value
		if (typeof value === 'object') {
			if (typeof value.message === 'string') return value.message
			return JSON.stringify(value)
		}
		return String(value)
	}

	if (error && typeof error === 'object') {
		if ('response' in error && error.response && typeof error.response === 'object') {
			const responseMessage = error.response.message || error.response.error?.message || error.response.error
			const message = stringifyMessage(responseMessage)
			if (message) return message || defaultMessage;
		}

		if ('message' in error && typeof error.message === 'string') {
			return error.message === '[object Object]' ? defaultMessage : error.message;
		}
	}

	return String(error) || defaultMessage;
}
